import { render, staticRenderFns } from "./AppLauncher.vue?vue&type=template&id=a79a47c2&scoped=true&lang=pug&"
import script from "./AppLauncher.vue?vue&type=script&lang=js&"
export * from "./AppLauncher.vue?vue&type=script&lang=js&"
import style0 from "./AppLauncher.vue?vue&type=style&index=0&id=a79a47c2&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a79a47c2",
  null
  
)

export default component.exports